// @flow
/**
 * Created by Mike Chung on 2/8/18.
 */

import type {LoadFairConfigFailedAction, LoadFairConfigSuccessAction} from "../fairConfigAction";
import FairConfig from "../../../model/fair/FairConfig";
import type {BootstrapAction, BootstrapPartDoneAction} from "../bootstrapAction";
import {loadFairConfigs} from "../../../dao/fairConfigDao";
import type {LoadCountryFailedAction, LoadCountrySuccessAction} from "../countryAction";
import {Country} from "../../../model/Country";
import {loadCountries} from "../../../dao/countryDao";
import {profileLoadAction} from "../../profile/creators/profileLoadActionCreator";
import {getProfile} from "../../../dao/localStorageProfileDao";
import type {JwtReadyAction} from "../../profile/jwtAction";
import config from "../../../config/config";

type GetState = () => any;
type Dispatch = (action: any) => any;
type ThunkAction = (dispatch: Dispatch, getState: ?GetState) => any;

function loadFairConfigSuccessAction(fairConfigs: Array<FairConfig>): LoadFairConfigSuccessAction {
    return {
        type: "app/LOAD_FAIR_CONFIG_SUCCESS_ACTION",
        fairConfigs: [].concat(fairConfigs)
    };
}

function loadFairConfigFailedAction(error: any): LoadFairConfigFailedAction {
    return {
        type: "app/LOAD_FAIR_CONFIG_FAILED_ACTION",
        error: error
    };
}

function loadCountrySuccessAction(countries: Array<Country>): LoadCountrySuccessAction {
    return {
        type: "app/LOAD_COUNTRY_SUCCESS_ACTION",
        countries: [].concat(countries)
    };
}

function loadCountryFailedAction(error: any): LoadCountryFailedAction {
    return {
        type: "app/LOAD_COUNTRY_FAILED_ACTION",
        error: error
    };
}

function bootstrapAction(count: number): BootstrapAction {
    return {
        type: "app/BOOTSTRAP",
        counter: count
    };
}

function appBootstrapPartDoneAction(): BootstrapPartDoneAction {
    return {
        type: "app/BOOSTRAP_PART_DONE"
    };
}

let loadProfileStep = function (dispatch) {
    try {

        dispatch(profileLoadAction(getProfile()));
        dispatch(appBootstrapPartDoneAction());
    } catch (e) {
        alert(e);
    }
};

let loadFairConfigsStep = function (dispatch, auth: string) {

    loadFairConfigs(auth).then((fairConfigs: Array<FairConfig>) => {
        dispatch(appBootstrapPartDoneAction());
        dispatch(loadFairConfigSuccessAction(fairConfigs));
    }).catch((e: any) => {
        dispatch(loadFairConfigFailedAction(e));
    });
};

let loadCountriesStep = function (dispatch) {
    loadCountries().then((countries: Array<Country>) => {
        dispatch(appBootstrapPartDoneAction());
        dispatch(loadCountrySuccessAction(countries));
    }).catch((e: any) => {
        dispatch(loadCountryFailedAction(e));
    });
};

let loadJwtStep = function (dispatch) {

    fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/saml/check`, {
        headers: {
            "content-type": "text/plain"
        },
        credentials: "include"
    }).then((response) => {
        if (response.status === 401) {

            let error = new Error(response.statusText);
            // $FlowFixMe
            error.response = response;
            throw error
        } else {

            return response.json();
        }
    }).then((res) => {

        let action: JwtReadyAction = {
            type: "profile/JWT_LOAD_SUCCESS_ACTION",
            jwt: res.jwt
        };
        dispatch(action);
        dispatch(appBootstrapPartDoneAction());
        return res.jwt;
    }).then((jwt) => {
        loadFairConfigsStep(dispatch, jwt);
    })
        .catch((e) => {
            const response = e.response;
            response.json().then((res) => {

                window.location.href = res.location;
            });
        });

};


export function appBootstrapAction(): ThunkAction {

    return async (dispatch) => {

        // When add a step which will dispatch appBootstrapPartDoneAction() please increment the count below
        dispatch(bootstrapAction(4));
        loadJwtStep(dispatch);
        loadProfileStep(dispatch);
        loadCountriesStep(dispatch);

    }
}


// WEBPACK FOOTER //
// ./src/actions/app/creators/bootstrapActionCreator.js